import { useState } from "react";
import api from "@/store/api";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";

const usePaylat = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const sendPaylat = async (data: { name: string; email: string; phoneNumber?: string; company: string }) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await api.post("/web/paylat/request", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (err: any) {
      console.error(err);
      setError(err.response?.data?.message || t("payLater.failedToSend"));
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { sendPaylat, isLoading, error };
};

export default usePaylat;
